import { t } from 'ttag'

export const INITIAL_VISIBLE_FACETS = 4

export const getAreaDetailSections = () => [
  {
    contributorsKey: 'increase_contributors',
    hint: t`The candidate scores high:`,
    sectionTone: 'Increase',
    title: t`Strengths`,
  },
  {
    contributorsKey: 'moderate_contributors',
    hint: null,
    sectionTone: 'Moderate',
    title: t`Areas for development`,
  },
  {
    contributorsKey: 'decrease_contributors',
    hint: t`The candidate scores low/high:`,
    sectionTone: 'Decrease',
    title: t`Stay away`,
  },
]
